import React, { ChangeEvent, useState } from "react";
import { CloseSquare, InfoCircle } from "iconsax-react";
import { api } from "../../utils/axios";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { getAllUserInfo } from "../../Store/UserAction.js";

interface TaskActionConfirmModalPropsType {
	task_id: number;
	requestLoading: boolean;
	setRequestLoading: (loading: boolean) => void;
	action: "approve" | "reject" | null;
	setAction: (action: "approve" | "reject" | null) => void;
}

const TaskActionConfirmModal = ({
	task_id,
	action,
	setAction,
}: TaskActionConfirmModalPropsType) => {
	const [note, setNote] = useState<string>("");
	const [requestLoading, setRequestLoading] = useState(false);
	const dispatch = useDispatch();

	const noteChangeHandler = (e: ChangeEvent<HTMLTextAreaElement>) => {
		setNote(e.target.value);
	};

	const handleConfirm = () => {
		if (requestLoading) return;

		setRequestLoading(true);

		api
			.patch(
				`/task/${task_id}/toggle_done`,
				{
					action: action,
					note: note,
				},
				{
					headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
				},
			)
			.then((res) => {
				dispatch(getAllUserInfo());
				setAction(null);
				toast.success("وضعیت تسک با موفقیت تغییر کرد");
			})
			.catch((error) => {
				toast.error("خطا در تغییر وضعیت تسک");
			})
			.finally(() => {
				setRequestLoading(false);
			});
	};

	if (!task_id || !action) {
		return;
	}
	return (
		action && (
			<div className="taskdetails-modal-overlay">
				<div className="taskdetails-modal tw-max-w-lg mx-auto">
					<button
						className="taskdetails-modal-close"
						onClick={() => setAction(null)}
					>
						&times;
					</button>
					<div className="taskdetails-modal-icon">
						<InfoCircle size={38} color="#3b82f6" variant="Bold" />
					</div>
					<div className="taskdetails-modal-message tw-text-blue-500">
						آیا از
						{action === "approve"
							? " تایید "
							: action === "reject"
								? " رد "
								: null}
						این تسک اطمینان دارید؟ در صورت لزوم میتوانید یادداشتی اضافه کنید
					</div>
					<div className={"form-group tw-w-full"}>
						<textarea
							name={"note"}
							className={"form-textarea "}
							value={note}
							placeholder="       یادداشت"
							rows={5}
							onChange={noteChangeHandler}
						/>
						{(!note || note.length === 0) && (
							<span className="input-icon input-icon-right tw-top-6 tw-right-4">
								<InfoCircle size={20} color="#7a7e9d" />
							</span>
						)}
					</div>
					<div className="taskdetails-modal-actions mt-5">
						{action === "approve" ? (
							<button
								className="taskdetails-actions-btn tw-text-green-600 tw-border-green-600 tw-w-1/2 tw-flex-shrink-0 hover:tw-bg-green-50"
								onClick={() => handleConfirm()}
							>
								<CloseSquare size={20} color="#16a34a" variant="Linear" /> تایید
								تسک
							</button>
						) : action === "reject" ? (
							<button
								className="taskdetails-actions-btn tw-text-red-600 tw-border-red-600 tw-w-1/2 tw-flex-shrink-0 hover:tw-bg-red-50"
								onClick={() => handleConfirm()}
							>
								<CloseSquare size={20} color="#dc2626" variant="Linear" /> رد
								تسک
							</button>
						) : (
							<></>
						)}
						<button
							className="taskdetails-modal-cancel-btn tw-w-1/2 tw-flex-shrink-0 tw-flex tw-justify-center"
							onClick={() => setAction(null)}
						>
							انصراف
						</button>
					</div>
				</div>
			</div>
		)
	);
};

export default TaskActionConfirmModal;
